import CryptoJS from "crypto-js";

export function generateSignature(method, path, timestamp) {
    const stringToSign = `${method}\n${path}\n${timestamp}`;
    return CryptoJS.HmacSHA256(stringToSign, atob("MjBjNjJiMzlhN2M0NWJhNDRhZjQyNjE2ZTI4NGM2YTE2MjkyNWM1Njk0NmI4OGZlMjAxZGYyYTkxNTM1MDhhNw==")).toString();
}
